import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import FormFieldStarPicker from '../fields/FormFieldStarPicker'
import FormFieldTextArea from '../fields/FormFieldTextArea'
import FormSubmitButton from '../FormSubmitButton'

export const Container = styled.div`
  height: 19rem;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
  background-color: ${({ theme }) => theme.colors.beige};

  @media ${mq(sizes.tablet)} {
    background-color: transparent;
  }
`

export const StarPickerField = styled(FormFieldStarPicker)``

export const TextAreaField = styled(FormFieldTextArea)`
  margin-top: 2.5rem;
  ::placeholder {
    ${({ theme }) => theme.textStyles.montserratTextBase}
    color: ${({ theme }) => theme.colors.greyFields};
  }
`

export const SubmitButton = styled(FormSubmitButton)`
  margin-top: 3.2rem;
  display: block;
  margin-left: auto;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
